import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Sidebar from './components/Sidebar';
import { Button, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import i18next from 'i18next';
import imgurl from './assests/images/imgurl';
import { useDispatch, useSelector } from 'react-redux';
import { clearImagesInRedux, trackEvent } from './utils/UtilityFunctions';
import AlertComp from './Alert';

const Preview = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const [isMobile, setIsMobile] = useState(false);
  const [alertopen, setalertopen] = useState(false)
  const [alertmsg, setalertmsg] = useState('analyze')
  const [radioValue, setRadioValue] = useState('yes')
  const [gender, setGender] = useState('')

  let { Topview, Leftview, Rightview, Frontview, Gender } = useSelector((state) => state.user.profile);

  useEffect(() => {
    if(Gender == '' && !location?.state?.user_obj?.gender){
      setGender(localStorage.getItem('gender'))
    } else if (location?.state?.user_obj?.gender) {
      setGender(location?.state?.user_obj?.gender)
    } else {
      setGender(Gender)
    }
  }, [])

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, [isMobile]);

  const handleRadioChange = async (value) => {
    try{
      setRadioValue(value) 
      await trackEvent('face_covered', 'success', '', localStorage.getItem('phno')) 
    } catch (err) {
      await trackEvent('face_covered', 'fail', err, localStorage.getItem('phno')) 
    }
  }

  const getResult = async () => {
    try{
      if(radioValue == 'no'){
        setalertmsg(i18next.t('Your face is not covered properly, please retake'))
        setalertopen(true)
      } else {
        if (Topview != '' && Frontview != '' && Rightview != '' && Leftview != '' && gender.toUpperCase() == "MALE") {
          await trackEvent('analyze_button_clicked', 'success', '', localStorage.getItem('phno')) 
          navigate('/clients', {state: {from: 'previewTest', user_obj: location?.state?.user_obj}})
        } else if (Topview != '' && Frontview != '' && gender.toUpperCase() == "FEMALE") {
          await trackEvent('analyze_button_clicked', 'success', '', localStorage.getItem('phno')) 
          navigate('/clients', {state: {from: 'previewTest', user_obj: location?.state?.user_obj}})
        }  else {
          setalertmsg('Please provide all images.')
          setalertopen(true)
          setTimeout(() => {
            setalertopen(false)
          }, 4000);
        }
      } 
    } catch (err) {
      console.log("err", err);
      await trackEvent('analyze_button_clicked', 'fail', err, localStorage.getItem('phno')) 
    }
  }

  const handleRetake = () => {
    if(((Frontview && Rightview && Leftview && Topview) && gender.toUpperCase() === "MALE") || 
      ((Frontview && Topview) && gender.toUpperCase() === "FEMALE")
    ){
      swal({
        title: i18next.t('Do you want to discard captured photos?'),
        buttons: {
          cancel: {
            text: i18next.t("No"),
            value: false,
            visible: true,
          },
          confirm: {
            text: i18next.t("Yes"),
            value: true,
            visible: true,
          },
        }
      }).then((val) => {
        if(val){  
          clearImagesInRedux(dispatch)
          if(localStorage.getItem('doctorLogged'))  {
            navigate('/taketest', {state:{ goTo: 'taketest'}});
          } else {
            navigate('/taketest', {state: {goTo: 'aloxa'}})
          }
        }
      })
    }  
  }

  return (
    <div className='previewpage photo-container main-section-container'>
      <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
        <Grid item xs={1} className=''>
          <div className='d-flex justify-content-start align-items-center'>
            <span className='backButtonDiv' onClick={() => navigate(-1, { state: { goTo: location?.state?.from }})}>
              <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
            </span>
          </div>
        </Grid>
        <Grid item xs={10} className='d-flex justify-content-center align-items-center'>
          <Typography variant="h6" className="title">{i18next.t("Preview")}</Typography>
        </Grid>
        <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
          <Sidebar/>
        </Grid>
      </Grid>
      <div className='preview-page-container'>
        {
          gender?.toUpperCase() === "MALE" ? 
          <>
            <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
              <Grid item xs={6} className='photocontainer'>
                <div className='photo-div'>
                  <img className={isMobile ? 'clickedphoto mobile' : 'clickedphoto'} src={Frontview ? `data:image/jpeg;base64,${Frontview}` : imgurl.frontImgPrev}/>
                </div>
              </Grid>
              <Grid item xs={6} className='photocontainer'>
                <div className='photo-div'>
                  <img className={isMobile ? 'clickedphoto mobile' : 'clickedphoto'} src={Topview ? `data:image/jpeg;base64,${Topview}` : imgurl.topImgPrev}/>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
              <Grid item xs={6} className='photocontainer'>
                <div className='photo-div'>
                  <img className={isMobile ? 'clickedphoto mobile' : 'clickedphoto'} src={Leftview ? `data:image/jpeg;base64,${Leftview}` : imgurl.rightImgPrev}/>
                </div>
              </Grid>
              <Grid item xs={6} className='photocontainer'>
                <div className='photo-div'>
                  <img className={isMobile ? 'clickedphoto mobile' : 'clickedphoto'} src={Rightview ? `data:image/jpeg;base64,${Rightview}` : imgurl.leftImgPrev}/>
                </div>
              </Grid>
            </Grid>
          </>
            : 
          <>
            <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
              <Grid item xs={12} className='photocontainer'>
                <div className='photo-div'>
                  <img className={isMobile ? 'clickedphoto mobile female' : 'clickedphoto female'} src={Frontview ? `data:image/jpeg;base64,${Frontview}` : imgurl.frontImgPrev}/>
                </div>
              </Grid>
              <Grid item xs={12} className='photocontainer'>
                <div className='photo-div'>
                  <img className={isMobile ? 'clickedphoto mobile female' : 'clickedphoto female'} src={Topview ? `data:image/jpeg;base64,${Topview}` : imgurl.topImgPrev}/>
                </div>
              </Grid>
            </Grid>
          </>
        }
        {/* <Grid item xs={12} className='pt-0px mt-10px mb-10px'>
          <div className='questionsSectionDiv'>
            <Typography>{i18next.t("Is your face covered?")}</Typography>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={radioValue}
              name="radio-buttons-group"
              onChange={(e) => handleRadioChange(e.target.value)}
            >
              <FormControlLabel value="yes" control={<Radio />} label={i18next.t("Yes")} />
              <FormControlLabel value="no" control={<Radio />} label={i18next.t("No")} /> 
            </RadioGroup>  
          </div>
        </Grid> */}
        <Grid container spacing={0} className='pt-0px mt-20px'>
          <Grid xs={6} className='preview-btn-container'>
            <Button
              className='retakeBtn'
              onClick={() => handleRetake()}
            >
              {i18next.t("Retake")}
            </Button>
          </Grid>
          <Grid xs={6} className='preview-btn-container'>
            <Button
              className='AnalyzeButton'
              onClick={() => getResult()}
            >
              {i18next.t("Proceed")}
            </Button>
          </Grid>
        </Grid>
        <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
      </div>
    </div>
  )
}

export default Preview